import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid", "sentinel", "loading"]
  static values = {
    url: String,
    page: { type: Number, default: 1 },
    pageParam: { type: String, default: "models_page" },
    cardSelector: { type: String, default: "[data-model-card]" },
    loading: { type: Boolean, default: false },
    done: { type: Boolean, default: false }
  }

  connect() {
    if (this.hasSentinelTarget && !this.doneValue) {
      this.observer = new IntersectionObserver(
        (entries) => { if (entries[0].isIntersecting) this.loadMore() },
        { rootMargin: "400px" }
      )
      this.observer.observe(this.sentinelTarget)
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  async loadMore() {
    if (this.loadingValue || this.doneValue) return
    this.loadingValue = true
    if (this.hasLoadingTarget) this.loadingTarget.classList.remove("hidden")

    const nextPage = this.pageValue + 1
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.pageParamValue, nextPage)

    try {
      const resp = await fetch(url, { headers: { "Accept": "text/html" } })
      if (!resp.ok) return

      const html = await resp.text()
      const doc = new DOMParser().parseFromString(html, "text/html")
      const newCards = doc.querySelectorAll(this.cardSelectorValue)

      if (newCards.length === 0) {
        this.doneValue = true
        this.observer?.disconnect()
        if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
        return
      }

      newCards.forEach(card => this.gridTarget.appendChild(card))
      this.pageValue = nextPage

      // Check if server signals no more pages
      const sentinel = doc.querySelector("[data-no-more]")
      if (sentinel) {
        this.doneValue = true
        this.observer?.disconnect()
      }
    } finally {
      this.loadingValue = false
      if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
    }
  }
}
